module.exports = __webpack_public_path__ + "static/media/logo.cb3f7ca0.png";